import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { FEATURES } from './core/features/features';
import { TimelineComponent } from './modules/admin/pages/timeline/timeline.component';
import { TrackingComponent } from './modules/admin/pages/tracking/tracking.component';
import { SettingsResolver } from './settings.resolver';

export const appRoutes: Route[] = [
	{
		path: '',
		canMatch: [AuthGuard],
		loadComponent: () =>
			import('./layout/layout.component').then((c) => c.LayoutComponent),
		resolve: { data: () => inject(SettingsResolver).resolve() },
		children: [
			{
				path: 'home',
				loadComponent: () =>
					import('app/modules/admin/home/home.component').then(
						(c) => c.HomeComponent,
					),
			},
			...(FEATURES.timeline
				? [
						{
							path: 'timeline',
							component: TimelineComponent,
						},
					]
				: []),

			...(FEATURES.tracking
				? [
						{
							path: 'tracking',
							component: TrackingComponent,
						},
					]
				: []),
			{
				path: 'admin',
				children: [
					...(FEATURES.locations
						? [
								{
									path: 'locations',
									loadChildren: () =>
										import('app/modules/admin/locations/locations.module').then(
											(m) => m.LocationsModule,
										),
								},
							]
						: []),
					...(FEATURES.staff
						? [
								{
									path: 'staff',
									loadChildren: () =>
										import('app/modules/admin/staff/staff.module').then(
											(m) => m.StaffModule,
										),
								},
							]
						: []),
					...(FEATURES.customers
						? [
								{
									path: 'customers',
									loadChildren: () =>
										import('app/modules/admin/customers/customers.module').then(
											(m) => m.CustomersModule,
										),
								},
							]
						: []),
					...(FEATURES.suppliers
						? [
								{
									path: 'suppliers',
									loadChildren: () =>
										import('app/modules/admin/suppliers/suppliers.module').then(
											(m) => m.SuppliersModule,
										),
								},
							]
						: []),
					...(FEATURES.agents
						? [
								{
									path: 'agents',
									loadChildren: () =>
										import('app/modules/admin/agents/agents.module').then(
											(m) => m.AgentsModule,
										),
								},
							]
						: []),
					...(FEATURES.vehicleDamages
						? [
								{
									path: 'vehicle-damages',
									loadChildren: () =>
										import(
											'app/modules/admin/vehicle-damages/vehicle-damages.module'
										).then((m) => m.VehicleDamagesModule),
								},
							]
						: []),
					...(FEATURES.rentalAgreements
						? [
								{
									path: 'rental-agreements',
									loadChildren: () =>
										import(
											'app/modules/admin/rental-agreements/rental-agreements.module'
										).then((m) => m.RentalAgreementsModule),
								},
							]
						: []),
					...(FEATURES.rentalReservations
						? [
								{
									path: 'rental-reservations',
									loadChildren: () =>
										import(
											'app/modules/admin/rental-reservations/rental-reservations.module'
										).then((m) => m.RentalReservationsModule),
								},
							]
						: []),

					...(FEATURES.transactions
						? [
								{
									path: 'transactions',
									loadChildren: () =>
										import(
											'app/modules/admin/transactions/transactions.module'
										).then((m) => m.TransactionsModule),
								},
							]
						: []),
					...(FEATURES.vehicles
						? [
								{
									path: 'vehicles',
									loadChildren: () =>
										import('app/modules/admin/vehicles/vehicles.module').then(
											(m) => m.VehiclesModule,
										),
								},
							]
						: []),
					...(FEATURES.vehicleInsurances
						? [
								{
									path: 'vehicle-insurances',
									loadChildren: () =>
										import(
											'app/modules/admin/vehicle-insurances/vehicle-insurances.module'
										).then((m) => m.VehicleInsurancesModule),
								},
							]
						: []),
					...(FEATURES.vehicleMaintenances
						? [
								{
									path: 'vehicle-maintenances',
									loadChildren: () =>
										import(
											'app/modules/admin/vehicle-maintenances/vehicle-maintenances.module'
										).then((m) => m.VehicleMaintenancesModule),
								},
							]
						: []),
					...(FEATURES.vehicleRoadTaxes
						? [
								{
									path: 'vehicle-road-taxes',
									loadChildren: () =>
										import(
											'app/modules/admin/vehicle-road-taxes/vehicle-road-taxes.module'
										).then((m) => m.VehicleRoadTaxesModule),
								},
							]
						: []),
					...(FEATURES.vehicleRoadWorthyChecks
						? [
								{
									path: 'vehicle-road-worthy-checks',
									loadChildren: () =>
										import(
											'app/modules/admin/vehicle-road-worthy-checks/vehicle-road-worthy-checks.module'
										).then((m) => m.VehicleRoadWorthyChecksModule),
								},
							]
						: []),
					//Redirects
					{
						path: 'vehicle-categories',
						redirectTo: 'vehicles/vehicle-categories',
					},

					{
						path: 'agent-categories',
						redirectTo: 'agents/agent-categories',
					},

					{
						path: 'vehicles-map',
						redirectTo: 'vehicles/map',
					},
					{
						path: 'locations-map',
						redirectTo: 'locations/map',
					},
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'vehicles',
					},
				],
			},
			{
				path: 'page-not-found',
				loadComponent: () =>
					import('app/modules/errors/pages/error-404/error-404.component').then(
						(c) => c.Error404Component,
					),
			},
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'home',
			},
		],
	},
	{ path: '**', redirectTo: 'page-not-found' },
];
